// extracted by mini-css-extract-plugin
export default {"textElement":"TextElement_textElement__r5wTE","input":"TextElement_input__l2+CS"};